export default __webpack_public_path__ + "066450c94de40829e957af4546c682a0.svg";